import { render, staticRenderFns } from "./POMForm.vue?vue&type=template&id=3e38b69a&"
import script from "./POMForm.vue?vue&type=script&lang=js&"
export * from "./POMForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports